import React, { FC } from 'react';
import { formatPipelineTimestamp } from 'utils/formatTimestamp';
import { toDetailEntries } from 'utils/formatters/orderPipelineAudit';
import { PipelineRunStep } from 'api/admin/orders/getOrderPipelineAudit';
import styles from './OrderPipelineHistory.module.scss';

interface PipelineStepItemProps {
  step: PipelineRunStep;
}

/**
 * Details are rendered generically: each UoW logs its own keys, so there is no fixed schema to map
 * against. A nested payload (e.g. `orderCalculations` logs `computed: { orderTotal, ... }`) is
 * expanded into labelled child rows rather than dumped as raw JSON.
 */
export const PipelineStepItem: FC<PipelineStepItemProps> = ({ step }) => (
  <div className={styles.step}>
    <div className={styles.stepHeader}>
      <span className={styles.stepUow}>{step.uow}</span>
      <span className={styles.runMeta}>{step.event}</span>
      <span className={styles.runMeta}>{formatPipelineTimestamp(step.at)}</span>
    </div>

    {toDetailEntries(step.details).map((entry) =>
      entry.children.length ? (
        <div className={styles.stepDetailGroup} key={entry.label}>
          <span className={styles.stepDetailKey}>{entry.label}</span>

          <div className={styles.stepDetailChildren}>
            {entry.children.map((child) => (
              <div className={styles.stepDetail} key={child.label}>
                <span className={styles.stepDetailKey}>{child.label}</span>
                <span>{child.value}</span>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className={styles.stepDetail} key={entry.label}>
          <span className={styles.stepDetailKey}>{entry.label}</span>
          <span>{entry.value}</span>
        </div>
      ),
    )}
  </div>
);
